<template lang="pug">
  .pdp-ingredients.xs-12
    #whats-in-our-color
      .info-wrap(v-if="!hideBunny")
        LeapingBunny

      .info(v-for="item in ingredients")
        h3.semi-bold.xs-f-small.lg-f-medium.capitalize.max-at-tweak.text-left.xs-mb-25m {{ getObjProperty(item, 'title') }}
        p.xs-f-small.lg-f-medium.capitalize.max-at-tweak.xs-mb-150m {{ getObjProperty(item, 'value') }}

</template>

<script>
  import LeapingBunny from '../LeapingBunny';

  export default {
    name: "PdpIngredients",

    components: {
      LeapingBunny
    },

    inject: ['getObjProperty'],

    props: {
      ingredients: {
        type: Array,
        default() {
          return [];
        }
      },
      hideBunny: {
        type: Boolean,
        default: false,
      }
    },
  };
</script>

<style scoped lang="stylus">
  .pdp-ingredients
    @media mq-mobile
      #whats-in-our-color
        overflow auto

</style>

